// @flow
import Summary from './Summary';

export default Summary;
